import React from "react";
import { useParams } from "react-router-dom";

import { getMaxCapacity } from "../../data";
import { useGetPartnerOffering } from "../../data/api";
import {
  Order,
  OrderItem,
  useLocationV2Query,
  useOrderQuery,
  useSpaceV2Query,
} from "../../offering/api";
import { getMainOrderItem } from "../../offering/order";
import { PartnerConfig } from "../../offering/partner_config";
import { getFieldFromObject } from "../utils/get_field_from_object";
import { TemplateOfferingConfirmOrderBaseV2 } from "./template_offering_confirm_order_base";
import { getPartnerOfferingName } from "@/offering/get_partner_offering_name";

interface TemplateOfferingConfirmOrderDailyOfficeParams {
  orderID: string;
  offeringID: string;
  spaceID: string;
  partnerOfferingLocationID?: string;
  capacity?: string;
  addOnID?: string;
}

interface TemplateOfferingConfirmOrderDailyOfficeProps {
  partnerConfig: PartnerConfig;
  confirmationMessage?: (
    order: Order,
    orderItem: OrderItem | undefined
  ) => React.ReactNode;
}

export function TemplateOfferingConfirmOrderDailyOffice(
  props: TemplateOfferingConfirmOrderDailyOfficeProps
) {
  const { partnerConfig, confirmationMessage } = props;
  const pageParams = useParams<TemplateOfferingConfirmOrderDailyOfficeParams>();
  const order = useOrderQuery(pageParams.orderID);
  const orderItem = getMainOrderItem(order);
  if (!orderItem) {
    throw new Error("Invalid order");
  }
  const partnerOfferingID = pageParams.offeringID;
  const partnerOffering = useGetPartnerOffering(partnerOfferingID);
  const details = getFieldFromObject("details", orderItem);

  const space = useSpaceV2Query(getFieldFromObject("spaceID", details));
  const location = useLocationV2Query(space.locationID);

  return (
    <TemplateOfferingConfirmOrderBaseV2
      numberOfInvites={
        getMaxCapacity(space) > 1
          ? getMaxCapacity(space)
          : orderItem.quantity > 1
          ? orderItem.quantity
          : undefined
      }
      partnerOfferingID={partnerOfferingID}
      partnerOffering={partnerOffering}
      offeringName={getPartnerOfferingName(partnerOffering)}
      partnerConfig={partnerConfig}
      confirmationMessage={confirmationMessage}
      order={order}
      location={location}
      space={space}
    />
  );
}
